import { useEffect, useRef, useState } from "react";
import { axiosRequest } from "../../utility/axios";
import { splitDesc } from "./hands.js";

// Big-screen display for the Hourly High Hand promo (8:00 PM - 12:00 AM IST, 10,000 per
// hour). Winners come from dealer hand entries (/dealer-hand) -- see getHighHandPublicCtrl
// in the backend for the rules (highest hand that hour, earliest wins a tie).

const POLL_MS = 5000;
const LAST_CALL_MINUTE = 55;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@900&family=Cinzel:wght@700;900&display=swap');
.hh-root{position:fixed;inset:0;overflow:hidden;color:#f5ecd2;font-family:'Cinzel','Georgia',serif;
  background:radial-gradient(ellipse at 50% 35%,#0f3d2a 0%,#06261a 45%,#020d08 100%);
  display:flex;flex-direction:column;padding:clamp(14px,2.4vh,30px) clamp(18px,2.6vw,48px);gap:clamp(10px,1.8vh,22px);}
.hh-top{display:flex;align-items:center;justify-content:space-between;gap:20px;}
.hh-brand{font-size:clamp(11px,1.2vw,18px);letter-spacing:6px;color:rgba(255,215,0,.65);}
.hh-clock{font-size:clamp(14px,1.6vw,26px);color:#fff;font-variant-numeric:tabular-nums;letter-spacing:2px;}
.hh-title{text-align:center;line-height:1.05;}
.hh-title-amt{font-family:'Cinzel Decorative','Georgia',serif;font-weight:900;font-size:clamp(34px,min(6.4vw,10vh),120px);
  background:linear-gradient(90deg,#9a6f00,#FFD700,#FFF3B0,#FFA500,#FFD700,#9a6f00);background-size:300%;
  -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:hh-shimmer 5s linear infinite;
  filter:drop-shadow(0 0 22px rgba(255,215,0,.35));}
.hh-title-sub{font-size:clamp(14px,min(2vw,3.2vh),36px);letter-spacing:clamp(3px,.6vw,10px);color:#fff;margin-top:4px;}
.hh-title-time{font-size:clamp(11px,1.2vw,18px);letter-spacing:4px;color:rgba(255,215,0,.75);margin-top:6px;}
@keyframes hh-shimmer{0%{background-position:0% center}100%{background-position:300% center}}

.hh-main{flex:1;min-height:0;display:grid;grid-template-columns:1.25fr 1fr;gap:clamp(12px,1.8vw,30px);}
.hh-panel{border:2px solid rgba(255,215,0,.45);border-radius:22px;background:rgba(0,0,0,.35);padding:clamp(14px,2vh,28px) clamp(16px,2vw,32px);
  display:flex;flex-direction:column;min-height:0;}
.hh-panel-h{font-size:clamp(11px,1.15vw,18px);letter-spacing:5px;color:rgba(255,215,0,.75);text-transform:uppercase;}
.hh-round{font-size:clamp(20px,2.6vw,44px);color:#fff;margin-top:4px;}
.hh-count{font-size:clamp(14px,1.5vw,24px);color:rgba(245,236,210,.8);margin-top:2px;font-variant-numeric:tabular-nums;}
.hh-lastcall{margin-top:10px;align-self:flex-start;background:#c0262d;color:#fff;border-radius:999px;padding:6px 18px;
  font-size:clamp(12px,1.4vw,22px);letter-spacing:3px;animation:hh-blink 1s step-start infinite;}
@keyframes hh-blink{50%{opacity:.35}}
.hh-leader{flex:1;min-height:0;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:6px;}
.hh-leader-lbl{font-size:clamp(11px,1.2vw,18px);letter-spacing:5px;color:rgba(255,215,0,.7);}
.hh-leader-hand{font-family:'Cinzel Decorative','Georgia',serif;font-weight:900;color:#FFD700;line-height:1.1;
  font-size:clamp(20px,min(3.8vw,6vh),76px);text-shadow:0 0 30px rgba(255,215,0,.5);}
.hh-leader-code{font-size:clamp(14px,min(2vw,3.4vh),40px);letter-spacing:clamp(4px,.6vw,12px);color:#fff;background:rgba(255,215,0,.1);
  border:1px solid rgba(255,215,0,.4);border-radius:12px;padding:4px 18px;font-family:Georgia,serif;font-weight:bold;}
.hh-leader-player{font-size:clamp(16px,min(2.6vw,4.2vh),50px);color:#fff;letter-spacing:2px;}
.hh-leader-at{font-size:clamp(11px,1.15vw,18px);color:rgba(245,236,210,.7);letter-spacing:2px;}
.hh-leader.bump{animation:hh-bump .9s cubic-bezier(.36,.07,.19,.97);}
@keyframes hh-bump{0%{transform:scale(1)}20%{transform:scale(1.08)}45%{transform:scale(.97)}70%{transform:scale(1.03)}100%{transform:scale(1)}}
.hh-none{font-size:clamp(16px,2vw,32px);color:rgba(245,236,210,.75);line-height:1.4;}
.hh-none b{color:#FFD700;}

.hh-slots{display:flex;flex-direction:column;gap:clamp(6px,1vh,12px);margin-top:clamp(8px,1.2vh,14px);flex:1;min-height:0;}
.hh-slot{flex:1 1 auto;min-height:min-content;display:grid;grid-template-columns:auto 1fr auto;align-items:center;gap:clamp(8px,1vw,18px);
  border:1px solid rgba(255,215,0,.22);border-radius:14px;padding:clamp(6px,1vh,12px) clamp(10px,1.2vw,20px);background:rgba(255,255,255,.03);}
.hh-slot-time{font-size:clamp(12px,1.25vw,21px);color:#fff;white-space:nowrap;}
.hh-slot-win{font-size:clamp(11px,1.15vw,19px);color:#FFD700;display:flex;flex-wrap:wrap;column-gap:10px;row-gap:2px;align-items:baseline;min-width:0;}
.hh-slot-win .id{color:#fff;flex-shrink:0;white-space:nowrap;}
.hh-slot-win .hand{min-width:0;overflow-wrap:anywhere;line-height:1.2;}
.hh-slot-win.muted{color:rgba(245,236,210,.45);}
.hh-tag{font-size:clamp(9px,.85vw,13px);letter-spacing:2px;border-radius:999px;padding:3px 10px;white-space:nowrap;}
.hh-tag.done{background:rgba(255,215,0,.16);color:#FFD700;}
.hh-tag.live{background:#c0262d;color:#fff;}
.hh-tag.upcoming{background:rgba(255,255,255,.08);color:rgba(245,236,210,.6);}
/* a finished round's winner gets a richer two-line row */
.hh-slot.won{flex:1.5;border-color:rgba(255,215,0,.55);background:linear-gradient(90deg,rgba(255,215,0,.12),rgba(255,215,0,.03));}
.hh-won{display:flex;flex-direction:column;gap:2px;min-width:0;}
/* the hand name drops under the ID and wraps rather than being cut off */
.hh-won-top{display:flex;flex-wrap:wrap;align-items:baseline;column-gap:12px;row-gap:2px;min-width:0;}
.hh-won-id{font-size:clamp(14px,1.5vw,26px);color:#fff;font-weight:900;flex-shrink:0;white-space:nowrap;}
.hh-won-hand{font-size:clamp(11px,1.15vw,19px);color:#FFD700;min-width:0;overflow-wrap:anywhere;line-height:1.2;}
.hh-won-sub{font-size:clamp(9px,.95vw,15px);color:rgba(245,236,210,.7);letter-spacing:1px;}
.hh-won-sub b{color:#FFD700;font-family:Georgia,serif;letter-spacing:2px;}
.hh-tag.prize{background:#FFD700;color:#1d1503;font-weight:900;}
.hh-slot.live{border-color:#FFD700;background:rgba(255,215,0,.08);box-shadow:0 0 18px rgba(255,215,0,.2);}

.hh-rules{display:flex;flex-wrap:wrap;justify-content:center;gap:clamp(8px,1vw,16px);}
.hh-rule{border:1px solid rgba(255,215,0,.3);border-radius:12px;padding:clamp(6px,.9vh,12px) clamp(10px,1.2vw,20px);
  font-size:clamp(10px,1.1vw,17px);letter-spacing:1px;color:rgba(245,236,210,.9);}
.hh-rule b{color:#FFD700;}
.hh-foot{text-align:center;font-size:clamp(10px,1.05vw,16px);letter-spacing:5px;color:rgba(255,215,0,.55);}

.hh-win-wrap{position:fixed;inset:0;z-index:30;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.55);}
.hh-win{border:3px solid #FFD700;border-radius:26px;background:rgba(4,24,15,.95);padding:clamp(20px,4vh,48px) clamp(28px,5vw,80px);text-align:center;
  box-shadow:0 0 90px rgba(255,215,0,.45);animation:hh-in .6s cubic-bezier(.34,1.56,.64,1);max-width:92vw;}
.hh-win-1{font-size:clamp(14px,1.6vw,26px);letter-spacing:6px;color:rgba(255,215,0,.8);}
.hh-win-2{font-family:'Cinzel Decorative','Georgia',serif;font-weight:900;font-size:clamp(34px,6vw,110px);color:#FFD700;line-height:1.1;margin:8px 0;}
.hh-win-3{font-size:clamp(18px,2.4vw,40px);color:#fff;}
.hh-win-4{font-size:clamp(14px,1.6vw,26px);color:rgba(245,236,210,.8);margin-top:8px;}
@keyframes hh-in{0%{transform:scale(.3);opacity:0}100%{transform:scale(1);opacity:1}}

/* shorter screens (laptops, 720p/768p TVs): trim the title, rules strip and rows so all
   four rounds fit with their full hand names */
@media (max-height:820px){
  .hh-title-amt{font-size:clamp(30px,min(6.4vw,8vh),120px);}
  .hh-title-time{margin-top:2px;}
  .hh-rules{gap:8px;}
  .hh-rule{font-size:max(10px,1.45vh);padding:.6vh 12px;}
  .hh-slots{gap:.8vh;}
  .hh-slot{padding:.6vh clamp(10px,1.2vw,20px);}
  .hh-slot-time{font-size:max(11px,1.9vh);}
  .hh-won-id{font-size:max(13px,2.4vh);}
  .hh-won-hand,.hh-slot-win{font-size:max(11px,1.85vh);}
  .hh-won-sub{font-size:max(9px,1.5vh);}
  .hh-tag{font-size:max(9px,1.3vh);}
}
@media (max-aspect-ratio:1/1){.hh-main{grid-template-columns:1fr;}.hh-slot{min-height:44px;}}
`;

const fmtClock = (ms) => new Date(ms).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit", second: "2-digit" });
const fmtHM = (d) => new Date(d).toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit" });
const fmtLeft = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
  return h ? `${h}h ${String(m).padStart(2, "0")}m` : `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};
const fmtAmt = (n) => Number(n || 0).toLocaleString("en-IN");

export default function HighHandDisplay() {
  const [data, setData] = useState(null);
  const [offset, setOffset] = useState(0); // server clock - device clock
  const [now, setNow] = useState(Date.now());
  const [winner, setWinner] = useState(null); // the just-finished round's winner overlay
  const [bump, setBump] = useState(false);
  const prevRef = useRef(null);

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const poll = async () => {
      try {
        const r = await axiosRequest("GET", `${process.env.REACT_APP_API_URL}/high-hand/public`, null);
        const d = r?.data;
        if (!d?.slots) return;
        if (d.server_now) setOffset(new Date(d.server_now).getTime() - Date.now());

        const prev = prevRef.current;
        if (prev && prev.date === d.date) {
          d.slots.forEach((s, i) => {
            const p = prev.slots[i];
            // a round just closed with a winner -> announce it
            if (p.status === "live" && s.status === "done" && s.leader) {
              setWinner({ ...s.leader, label: s.label });
              setTimeout(() => setWinner(null), 45000);
            }
            // a new, better hand took the lead in the live round
            if (s.status === "live" && s.leader && (!p.leader || p.leader.at !== s.leader.at)) {
              setBump(true);
              setTimeout(() => setBump(false), 1000);
            }
          });
        }
        prevRef.current = d;
        setData(d);
      } catch {}
    };
    poll();
    const t = setInterval(poll, POLL_MS);
    return () => clearInterval(t);
  }, []);

  const serverNow = now + offset;
  const prize = data?.prize ?? 10000;
  const slots = data?.slots || [];
  // promo hours come from the backend (HIGH_HAND_START_HOUR); fallbacks match it
  const hours = slots.length || 4;
  const startLabel = data?.start_label || "8:00 PM";
  const endLabel = data?.end_label || "12:00 AM";
  const tagline = `${hours} Hours · ${hours} Winners · ${fmtAmt(prize * hours)} Total Prizes`;
  const live = slots.find((s) => s.status === "live");
  const started = slots.length && serverNow >= new Date(slots[0].start).getTime();
  const allDone = slots.length && slots.every((s) => s.status === "done");
  const minuteOfHour = Number(new Date(serverNow).toLocaleString("en-US", { timeZone: "Asia/Kolkata", minute: "numeric" }));
  const lastCall = !!live && minuteOfHour >= LAST_CALL_MINUTE;

  return (
    <div className="hh-root">
      <style>{CSS}</style>

      <div className="hh-top">
        <div className="hh-brand">♠ REAL CLUB ♠</div>
        <div className="hh-clock">{fmtClock(serverNow)}</div>
      </div>

      <div className="hh-title">
        <div className="hh-title-amt">💰 {fmtAmt(prize)} Every Hour 💰</div>
        <div className="hh-title-sub">High Hand Jackpot</div>
        <div className="hh-title-time">🕕 {startLabel} – {endLabel} 🕕</div>
      </div>

      <div className="hh-main">
        <div className="hh-panel">
          {live ? (
            <>
              <div className="hh-panel-h">Current Round</div>
              <div className="hh-round">{live.label}</div>
              <div className="hh-count">Ends in {fmtLeft(new Date(live.end).getTime() - serverNow)}</div>
              {lastCall && <div className="hh-lastcall">🔔 LAST HAND CALL</div>}
              <div className={`hh-leader${bump ? " bump" : ""}`}>
                {live.leader ? (
                  <>
                    <div className="hh-leader-lbl">Current High Hand</div>
                    <div className="hh-leader-hand">{splitDesc(live.leader.hand_label).name}</div>
                    {splitDesc(live.leader.hand_label).code && <div className="hh-leader-code">{splitDesc(live.leader.hand_label).code}</div>}
                    <div className="hh-leader-player">{live.leader.player_id}</div>
                    <div className="hh-leader-at">at {fmtHM(live.leader.at)}</div>
                  </>
                ) : (
                  <div className="hh-none">No qualifying hand yet<br /><b>Full House or better</b> takes the lead</div>
                )}
              </div>
            </>
          ) : allDone ? (
            <div className="hh-leader">
              <div className="hh-leader-lbl">Tonight's Promotion Has Ended</div>
              <div className="hh-leader-hand">Thank You!</div>
              <div className="hh-leader-at">Back tonight from {startLabel}</div>
            </div>
          ) : (
            <div className="hh-leader">
              <div className="hh-leader-lbl">{started ? "" : `Promotion Starts At ${startLabel}`}</div>
              <div className="hh-leader-hand">{slots.length ? fmtLeft(new Date(slots[0].start).getTime() - serverNow) : "--"}</div>
              <div className="hh-leader-at">{tagline}</div>
            </div>
          )}
        </div>

        <div className="hh-panel">
          <div className="hh-panel-h">Tonight's Winners</div>
          <div className="hh-slots">
            {slots.map((s) => (
              <div className={`hh-slot ${s.status}${s.status === "done" && s.leader ? " won" : ""}`} key={s.label}>
                <div className="hh-slot-time">{s.label}</div>
                {s.status === "done" && s.leader ? (
                  <div className="hh-won">
                    <div className="hh-won-top">
                      <span className="hh-won-id">🏆 {s.leader.player_id}</span>
                      <span className="hh-won-hand">{splitDesc(s.leader.hand_label).name}</span>
                    </div>
                    <div className="hh-won-sub">
                      {splitDesc(s.leader.hand_label).code && <><b>{splitDesc(s.leader.hand_label).code}</b> · </>}at {fmtHM(s.leader.at)}
                    </div>
                  </div>
                ) : s.leader ? (
                  <div className="hh-slot-win"><span className="id">{s.leader.player_id}</span><span className="hand">{splitDesc(s.leader.hand_label).name}</span></div>
                ) : (
                  <div className="hh-slot-win muted">{s.status === "done" ? "No qualifying hand" : s.status === "live" ? "Waiting for Full House+" : "—"}</div>
                )}
                <div className={`hh-tag ${s.status}${s.status === "done" && s.leader ? " prize" : ""}`}>{s.status === "done" ? (s.leader ? `WON ${fmtAmt(prize)}` : "CLOSED") : s.status === "live" ? "LIVE" : "UPCOMING"}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="hh-rules">
        <div className="hh-rule">🃏 Minimum: <b>Full House or Better</b></div>
        <div className="hh-rule">🔔 <b>Last Hand Call</b> at :55 every hour</div>
        <div className="hh-rule">♠️ Tie: <b>first to make the hand wins</b></div>
        <div className="hh-rule">⚖️ Verified by dealer / floor · <b>Floor decision final</b></div>
      </div>
      <div className="hh-foot">🔥 {tagline} 🔥</div>

      {winner && (
        <div className="hh-win-wrap" onClick={() => setWinner(null)}>
          <div className="hh-win">
            <div className="hh-win-1">🏆 {winner.label} WINNER 🏆</div>
            <div className="hh-win-2">{winner.player_id}</div>
            <div className="hh-win-3">{winner.hand_label}</div>
            <div className="hh-win-4">Wins {fmtAmt(prize)}!</div>
          </div>
        </div>
      )}
    </div>
  );
}
